import ClassNames from "classnames";
import * as React from "react";
import Styles from "./Slider.module.css";

export interface Props {
  id?: string;
  className?: string;
  name?: string;
  defaultValue?: number;
  minValue?: number;
  maxValue?: number;
  handleChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const Slider: React.FC<Props> = props => {
  const {
    id,
    className,
    name,
    handleChange,
    defaultValue,
    minValue,
    maxValue
  } = props;

  return (
    <input
      id={id}
      className={ClassNames({
        [Styles.slider]: true,
        [className]: className
      })}
      type="range"
      name={name}
      step="1"
      defaultValue={defaultValue}
      aria-valuenow={defaultValue}
      aria-valuemin={minValue}
      aria-valuemax={maxValue}
      aria-labelledby={name}
      onChange={handleChange}
    />
  );
};

export default Slider;
